import Marquee from "../../ui/Marquee";
import { companies } from "./data";

const TrustedCompanies = () => {
  return (
    <section className="mt-[114px]">
      <h4 className="text-[#888888] font-medium text-center px-8  mb-8">
        Trusted by{" "}
        <span className="font-bold text-[#1C1C1C]">dozens of companies</span>{" "}
        and startups like
      </h4>

      <Marquee
        pauseOnHover
        className="lg:[--duration:40s] [--duration:30s] bg-primary-500 lg:[--gap:56px] [--gap:20px] gap-1 lg:gap-14 py-0 lg:py-3 h-8 md:h-10 lg:h-auto"
      >
        {companies.map((company, key) => (
          <img key={key} {...company} />
        ))}
      </Marquee>
    </section>
  );
};

export default TrustedCompanies;
